
import { addAuthToHeader, BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicCategoriesApi extends BaseModulePublicApi {
  basePath = 'categories';

  /**
   * Returns the active category hierarchy used by the guided visit.  Keeping
   * this here avoids each client having to reconstruct it from a flat list.
   */
  async getVisitTree(categoryType = 'points_of_interest', headers: any = null, configOptions?: any) {
    const response = await this.axiosInstance!.get(`/front/${this.domain}/${this.basePath}/visit`, {
      params: { category_type: categoryType },
      headers: addAuthToHeader(headers ?? {}, this.token),
      ...configOptions,
    });
    if (response.status === 200) return response.data;
  }
};
